import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const NotificationManagementHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Notification management</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default NotificationManagementHeader;
